import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import { CapturaStore, UserStore } from '../../stores';

import FooterToolbar from 'ant-design-pro/lib/FooterToolbar';
import { Button } from 'antd';
import { RegistroImpuestosAguaForm } from '../RegistroImpuestosAguaForm';
import { RegistroImpuestosPredialForm } from '../RegistroImpuestosPredialForm';
import { CapturaHeader } from './CapturaHeader';
import StepStatus from './StepStatus';

interface CapturaProps extends RouteComponentProps {
    capturaStore?: CapturaStore;
    userStore?: UserStore;
}

const CapturaPageContentWrapper = styled.div`
    margin: 24px 24px 0;
    .ant-steps-item-process>.ant-steps-item-icon{
        background-color:#a8123e !important;
        border-color:#a8123e !important;
        color:#fff !important;
    }
    .ant-steps-item-finish .ant-steps-item-icon {
        border-color:#a8123e !important;
    }
    .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon{
        color:#a8123e !important;
    }
    .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title::after{
        background-color:#a8123e !important;
    }
`;

const CapturaPageContent = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

@inject('capturaStore')
@inject('userStore')
@observer
class CapturaInner extends React.Component<CapturaProps, {}> {
    async componentDidMount() {
        const { userStore, capturaStore } = this.props;

        await userStore!.getUsuario();
        capturaStore!.initialize();
    }

    render() {
        const { capturaStore } = this.props;
        const { selectedRegistroKind, registroImpuestosStore } = capturaStore!;
        const { isReadonly, canSubmit, isSubmitting, submitForm } = registroImpuestosStore;
        const { estado } = registroImpuestosStore.registroImpuestos;
        const stylePrimary = {
            backgroundColor:'#a8123e', borderColor:'#a8123e'
        };
        return (
            <>
                <CapturaHeader />
                <CapturaPageContentWrapper>
                    <CapturaPageContent>
                        <StepStatus estado={estado} />
                        {selectedRegistroKind === 'Predial' ? (
                            <RegistroImpuestosPredialForm />
                        ) : (
                            <RegistroImpuestosAguaForm />
                        )}
                    </CapturaPageContent>
                    {!isReadonly && canSubmit && (
                        <FooterToolbar extra="">
                            <Button type="primary" loading={isSubmitting} onClick={submitForm} style={stylePrimary}>
                                Enviar
                            </Button>
                        </FooterToolbar>
                    )}
                </CapturaPageContentWrapper>
            </>
        );
    }
}

export const Captura = withRouter(CapturaInner);
